<template>
  <div id="navbar">
    
    <!-- <div class="snowflakes" aria-hidden="true">
      <div class="snowflake">🔥</div>
      <div class="snowflake">🥵</div>
      <div class="snowflake">🏜</div>
      <div class="snowflake">♨️</div>
      <div class="snowflake">🥵</div>
      <div class="snowflake">🏜</div>
      <div class="snowflake">🔥</div>
      <div class="snowflake">♨️</div>
      <div class="snowflake">🏜</div>
      <div class="snowflake">🥵</div>
      <div class="snowflake">🏜</div>
      <div class="snowflake">🔥</div>
      <div class="snowflake">🥵</div>
    </div> -->
    <!-- <div class="halloween">
         <img src="../../assets/halloween/24-249691_ghost-laughing-clipart-free-picture-transparent-png-ghost.png" alt="" class="ghost">
       <img src="../../assets/halloween/png-clipart-ghost-ghost.png" alt="" class="ghost01">
       </div> -->
    <nav class="navbar tiger navbar-light bg-faded navbar-expand">
      <div class="container">
        <nav class="navbar navbar-light bg-faded navbar-expand-lg" shadow="">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a href="tel:045352056" target="_self" class="item-color"
                ><i class="fas fa-phone fa-sm top-icon"></i> contact</a
              >
            </li>
            <li class="nav-item">
              <a
                href="mailto: info.lib@ubru.ac.th"
                rel="noopener noreferrer"
                target="_blank"
                class="item-color"
                ><i class="fas fa-envelope fa-sm top-icon"></i>
                info.lib@ubru.ac.th
              </a>
            </li>
            <li class="nav-item">
              <a
                href="UBRU-Smart-booking-Manual-min.pdf"
                rel="noopener noreferrer"
                class="item-color"
                target="_blank"
              >
                <i class="fas fa-book-reader"></i>
                คู่มือ
              </a>
            </li>
          </ul>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a
                href="https://www.facebook.com/UBRUlibrary"
                rel="noopener"
                target="_blank"
                class="item-color"
                ><i class="fab fa-facebook-square fa-sm top-icon"></i
              ></a>
            </li>
            <li class="nav-item">
              <a
                href="https://www.youtube.com/channel/UCrX7jl0AyiXuCV4bc2ZWPig"
                rel="noopener"
                target="_blank"
                class="item-color"
                ><i class="fab fa-youtube fa-sm top-icon"></i
              ></a>
            </li>
            <li class="nav-item">
              <a
                href="https://lin.ee/wDCCbDK"
                rel="noopener"
                target="_blank"
                class="item-color"
                ><i class="fab fa-line fa-sm top-icon"></i
              ></a>
            </li>
            <li class="nav-item">
              <a
                href="https://lib.ubru.ac.th/"
                rel="noopener"
                target="_blank"
                class="item-color"
                ><i class="fas fa-globe fa-sm top-icon"> </i> เว็บไซต์หลัก</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </nav>

    <nav id="nav" class="shadow-sm bg-white rounde">
      <div class="container">
      <b-navbar
        toggleable="lg"
        variant="faded"
        type="light"
        shadow
        class="navbar2-size"
      >
       
          <b-navbar-brand href="/">
            <!-- <img
              src="../../assets/logos/oct2022_icon.png"
              class="d-inline-block align-top img-logo"
              alt="Kitten"
            />
            <img
              src="../../assets/halloween/png-clipart-hallween-pumpkin-halloween.png"
              alt=""
              class="pumkin"
            /> -->
             
            <img
              src="../../assets/logos/LOGO_UBRUlib_Orange_noom_cap.png"
              class="d-inline-block align-top img-logo"
              alt="Kitten"
            />
            <!-- <img src="../../assets/loykrathong/loy-krathong.png" alt="" class="icon-krathong1"> -->
            <!-- <img src="../../assets/football/animation_500_laq3j5ri.gif" alt=""  class="icon-football"> -->
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <router-link
                to="/"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
                หน้าแรก
              </router-link>
              <a
                class="nav-item nav-link"
                active-class="active"
                exact
                href="https://elibrary-ubru.cu-elibrary.com"
                target="_blank"
                >E-book</a
              >
              <!-- <router-link
                to="https://elibrary-ubru.cu-elibrary.com"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
              E-book
              </router-link>  -->
              <!-- <router-link
                to="/blog"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
               Blog
              </router-link> -->
              <router-link
                to="renew"
                class="nav-item nav-link"
                active-class="active"
                exact
                v-if="chk_auth && !staff"
              >
                ยืมปัจจุบัน
              </router-link>
              <router-link
                to="booking"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
                จองหนังสือ
              </router-link>
              <router-link
                to="BookingRoom"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
                จองห้อง
              </router-link>
              <!-- <router-link
                to="search"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
             ค้นหาหนังสือ
              </router-link> -->
              <!-- <router-link  
                to="duedate"
                class="nav-item nav-link"
                active-class="active"
                exact
                v-if="chk_auth && !staff">
                กำหนดส่ง
              </router-link> -->

              <router-link
                to="checkOrder"
                class="nav-item nav-link"
                active-class="active"
                exact
                v-if="chk_auth && !staff"
              >
                รายการจอง

                <span class="badge badge-purple-jong">
                  {{
                    setorders.length +
                    +(setorders.length > 1 || setorders.length === 0 ? " " : "")
                  }}
                </span>
              </router-link>
              

              <!-- <router-link
                to="newbook"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
                หนังสือแนะนำ
              </router-link> -->
              <router-link
                to="staff"
                class="nav-item nav-link"
                active-class="active"
                exact
                v-show="staff"
              >
                Saff
              </router-link>

              <b-nav-item
                data-toggle="modal"
                data-target=".bd-example-modal-lg"
                v-show="chk_auth && !staff"
              >
                <!-- <i class="fas fa-cart-arrow-down fa-sm"></i> -->
               <!-- Helloween -->
                  <!-- <i class="fa-solid fa-book-skull fa-lg"></i> -->
                  <!-- Christmas -->
                  <!-- <i class="fa-solid fa-gift"></i> -->
                 <!-- &nbsp;  -->
                 <!-- <i class="fa-solid fa-swatchbook"></i> -->
                 <!-- <i class="fa-solid fa-burger fa-lg"></i> -->
                 <i class="fa-solid fa-cart-flatbed"></i>
                 &nbsp;
                 <!-- badge-purple  -->
                <span class="badge badge-purple-noti">
                  {{
                    booking.length +
                    +(booking.length > 1 || booking.length === 0 ? "0" : "")
                  }}
                </span>
                |
              </b-nav-item>
              <router-link
                to="profile"
                class="nav-item nav-link"
                active-class="active"
                exact
                v-if="chk_auth && !staff"
              >
                โปรไฟล์
              </router-link>
              <router-link
                v-if="!chk_auth"
                to="login"
                class="nav-item nav-link"
                active-class="active"
                exact
              >
                เข้าสู่ระบบ
              </router-link>

              <!-- <b-nav-item-dropdown text="Lang" right>
                <b-dropdown-item href="#">EN</b-dropdown-item>
                <b-dropdown-item href="#">ES</b-dropdown-item>
                <b-dropdown-item href="#">RU</b-dropdown-item>
                <b-dropdown-item href="#">FA</b-dropdown-item>
              </b-nav-item-dropdown> -->

              <b-nav-item-dropdown right v-if="chk_auth">
                <template #button-content>
                  <em>{{ auth.std_name }}</em>
                </template>
                
                <b-dropdown-item href="/profile"  v-if="chk_auth">โปรไฟล์</b-dropdown-item>
                <b-dropdown-item @click="logout()">ออกจากระบบ</b-dropdown-item>

              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        </div>
     
    </nav>

    <div
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">รายการหนังสือ</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="grey-bg container-fluid">
              <section id="stats-subtitle">
                <div class="row">
                  <div
                    class="col-xl-12 col-md-12"
                    v-for="(item, index) in booking"
                    :key="index"
                    transition="fade"
                  >
                    <div class="card overflow-hidden item-modal shadow mb-4">
                      <div class="card-content">
                        <div class="card-body cleartfix">
                          <div class="media align-items-stretch">
                            <div class="align-self-center">
                              <img
                                :src="item.img_url"
                                alt=""
                                class="modal-img icon-pencil primary font-large-2 mr-2"
                              />
                              <!-- <i
                                  class="icon-pencil primary font-large-2 mr-2"
                                ></i> -->
                            </div>

                            <div class="media-body txt-modal">
                              <h6>
                                ชื่อหนังสือ |
                                {{ item.book_title.slice(0, 40) }}...
                              </h6>
                              <h6>
                                ชื่อผู้แต่ง|
                                {{ item.book_author.slice(0, 30) }}
                              </h6>
                              <!-- <span>Monthly blog posts</span> -->
                            </div>
                            <div class="align-self">
                              <div>
                                <span class="badge badge-purple">{{
                                  item.qty_booking
                                }} เล่ม </span>
                              </div>
                              <br />
                              <i
                                class="fas fa-trash-alt fa-lg"
                                @click="removeFromCart(item)"
                              ></i>
                              <!-- <h1>18,000</h1> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div class="modal-footer" v-if="status_login">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              class="btn btn-purple"
              data-dismiss="modal"
              @click="sendItem(booking)"
              v-if="booking.length >= 1"
            >
              จองหนังสือ
            </button>
          </div>
          <div class="modal-footer" v-if="!status_login">
            <a href="/login" type="button" class="btn btn-info"> จองหนังสือ </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
export default {
  props: ["booking", "setorders", "count"],
  name: "Navbar",
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.chk_auth = true;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      if (localStorage.getItem("maxchk") == null) {
        this.qty_borrow_max_chk = this.auth.qty_borrow_max;
        localStorage.setItem("maxchk", this.auth.qty_borrow_max);
      }
      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    }

    if (localStorage.getItem("login") === null) {
      this.status_login = false;
      localStorage.setItem("login", this.status_login);
    } else {
      this.status_login = true;
      localStorage.setItem("login", this.status_login);
    }

    if (localStorage.getItem("booking") != null) {
      this.data_booking = JSON.parse(localStorage.getItem("booking"));

      // this.chkMaxBorrow()
    }
    if (JSON.parse(localStorage.getItem("booking")).length === 0) {
      this.length_booking = 0;
      localStorage.setItem("chkqty", this.length_booking);
    }
    if (localStorage.getItem("orders") != null) {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    }

    this.status();
    /*! Main */
    (function ($) {
      "use strict";

      var $navbar = $("#nav"),
        y_pos = $navbar.offset().top,
        height = $navbar.height();

      $(document).scroll(function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > y_pos + height) {
          $navbar.addClass("fixed-top").animate({
            top: 0,
          });
          $navbar.addClass("shadow mb-5 bg-white rounded");
        } else if (scrollTop <= y_pos) {
          $navbar.removeClass("fixed-top").clearQueue().animate(
            {
              top: "-48px",
            },
            0
          );
          $navbar.clearQueue().animate(
            {
              top: "-48px",
            },
            0
          );
        }
      });
    })($, undefined);
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  data() {
    return {
      loggedIn: false,
      qty: [],
      filteredArr: [],
      showCart: false,
      verified: false,
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      orders: [],
      auth: [],
      status_login: false,
      staff: false,
      data_booking: [],
      chk_qty: [],
      length_booking: 0,
      chk_auth: false,
    };
  },
  methods: {
    removeFromCart(item) {
      if (this.booking.length === 0) {
        this.length_booking = 0;
        localStorage.setItem("chkqty", this.length_booking);
      } else {
        this.length_booking = localStorage.getItem("chkqty");

        this.length_booking -= item.qty_booking;
        localStorage.setItem("chkqty", this.length_booking);
      }

      item.qty_booking = 0; //fillter
      this.booking.splice(this.booking.indexOf(item), 1);
      localStorage.setItem("booking", JSON.stringify(this.booking));
    },
    sendItem(items) {
      let IP = localStorage.getItem("IP");

      let data = {
        token: this.token,
        books: items,
        std_code: this.code,
        staff_code: "",
        public_ip: IP,
      };

      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/datas", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            let order = res.data.Orders;
            this.orders = res.data.Orders;
            if (order === null) {
              localStorage.setItem("orders", "null");
            } else {
              localStorage.setItem("orders", JSON.stringify(order));
            }
            this.booking = [];
            localStorage.setItem("booking", JSON.stringify(this.booking));
            localStorage.setItem("chkqty", JSON.stringify(this.chkqty));
            this.$isLoading(false);
            this.$router.push("checkOrder");
          }
        });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        localStorage.removeItem("orders");
        this.$router.push("/");
      });
    },
    status() {
      if (!localStorage.getItem("access_token")) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");
em{
  font-family: "Kanit", sans-serif;
}
.modal-content{
  font-family: "Kanit", sans-serif;
}
.modal-content .modal-title{
  font-family: "Kanit", sans-serif;
  font-weight: bold;
}
.badge-purple-noti{
  /* #FF7e00  #f9476c;*/
  background-color:  #FF7e00;
  color: white;
  position: relative;
  top: -13px;
  left: -10px;
  width: 17px;
  height: 17px;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  justify-content: center;
  align-items: center;
  border-radius: 70% !important;
  font-size: 12px;
  font-family: "Kanit", sans-serif;
}
.badge-purple-jong {
  background-color:  #FF7e00;
  color: white;
  position: relative;
  top: -13px;
  left: -10px;
  width: 17px;
  height: 17px;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  border-radius: 70% !important;
  font-size: 12px;;
}

/* .icon-noti {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* .icon-button__badge_myjob {
  position: absolute;
  top: 15px;
  left: 34px;
  width: 15px;
  height: 15px;
  background: red;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px;
} */
.item-color {
  font-family: "Kanit", sans-serif;
  color: #fff;
  display: block;
  padding: 0.5rem 1rem;
}
.badge-purple {
  background-color:  #FF7e00;
  color: white;
}

.top-icon {
  color: #ffffff;
}
.img-logo {
  /*width: 230px;*/
   width: 190px; 
  height: 100%;
}
/* halloween */
 /* .img-logo {
  width: 70px;
  height: 100%;
}  */
.tiger {
  /* loykrathong */
  /* background-image: url('../../assets/loykrathong/6460522-bg.jpg');
   background-size: center; #ff5f2d  */

   background: rgb(255,95,45);
   background: linear-gradient(80deg, rgba(255,95,45,1) 41%, rgba(250,129,40,1) 71%);
    /* original */
   /* background: -webkit-linear-gradient(
    -55deg,
    #f82274 40%,
    #ff8195 100%
  ) !important;*/
  /* background: -webkit-linear-gradient(
    -55deg,
    #2F0743 40%,
    #f82274 100%
  ) !important; */
  /* halloween */
   /* background: -webkit-linear-gradient(
    -55deg,
    #000000 40%,
    #F46306 100%
  ) !important;  */
  /* สีชมพู */
  /*background: -webkit-linear-gradient(
    -55deg,
    #000000 40%,
    #ff8195 100%
  ) !important;*/
  /*  */
  /* สีส้ม */
  /* background: -webkit-linear-gradient(
    -55deg,
    #FC6A03 40%,
    #FA8128 100%
  ) !important; */
  /*  */

  /* background-color: #2b99d8;
  #2066bb */
}

.navbar2-size {
  padding: 0.5rem 0.5rem;
}
.navbar-fixed {
  position: fixed;
  /* top: -(info); */

  font-family: "Kanit", sans-serif;
}
.navbar{
  padding: 0  !important;
  font-family: "Kanit", sans-serif;
}
/*----------------------
  $NAVBAR
    basic navbar styling
  ----------------------*/

nav ul li :hover {
  /* color: #482088; */
  /* background-color: rgba(204, 204, 204, 0.214); */
  text-decoration: none;
}

nav {
  width: 100%;
  color: #fff;
  /* background: #00939c; */
  font-weight: bold;
  letter-spacing: 0.025em;
  font-family: "Kanit", sans-serif;
}

nav ul {
  text-align: center;
  margin: 0;

  font-family: "Kanit", sans-serif;
}
/* 
nav ul li {
  display: inline-block;
  padding: 0 3em;
  line-height: 3em;
} */

nav ul li:hover {
  /* background: #ffffff; */

  font-family: "Kanit", sans-serif;
}

.filler {
  width: 1px;
  height: 200px;
}

.two {
  height: 1000px;
}

.txt-modal {
  text-align: left;
  font-family: "Kanit", sans-serif;
}
.card-body-modal {
  bottom: 50px;
  font-family: "Kanit", sans-serif;
}
.modal-img {
  height: 90px;
}
.item-cart {
  padding: 20px;
}
.item-modal {
  padding: 0px;
}
.card #cart-modal {
  padding: 0px;
  font-family: "Kanit", sans-serif;
}
.fade-transition {
  transition: all 0.2s ease-out;
}

.fade-enter,
.fade-leave {
  opacity: 0;
}
/* halloween */
.halloween {
  position: relative;
}
.ghost {
  position: absolute;
  margin-top: 10%;
  right: 0%;
  /* left: 10%; */
  z-index: 999;
  width: 160px;
  height: auto;
}
.ghost01 {
  position: absolute;
  margin-top: 50%;
  /* right: 0%; */
  left: 0%;
  z-index: 999;
  width: 200px;
  height: auto;
}
.pumkin {
  position: absolute;
  margin-top: 0.3%;
  /* right: 55%; */
  /* left: 10%; */
  z-index: 999;
  width: 160px;
  height: auto;
}
@media screen and (max-width: 1200px) {
  .ghost {
    display: none;
  }
  .ghost01 {
    display: none;
  }
  .icon-krathong1 {
    display: none;
  }
  .icon-football{
    display:none;
  }
}



@keyframes float {
  0% {
    /* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
    transform: translatey(0px);
  }
  50% {
    /* box-shadow: 0 25px 15px 0px rgba(0,0,0,0.2); */
    transform: translatey(-13px);
  }
  100% {
    /* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
    transform: translatey(0px);
  }
}
.icon-krathong1 {
  animation: float 6s ease-in-out infinite;
  position: absolute;
  margin-top: 1.3%;
  right: 3%;
  left: -6%;
  z-index: 666;
  width: 50px;
  height: auto;
}
.icon-football{
 
 position: absolute;
 margin-top: -0.5%;
 right: 3%;
 left: -6%;
 z-index: 666;
 width: 70px;
 height: auto;
}
/* christmas */
/* customizable snowflake styling */
.snowflake {
  color: #fff;
  font-size: 1.5em;
  font-family: Arial;
  text-shadow: 0 0 1px rgb(255, 255, 255);
}

@-webkit-keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@-webkit-keyframes snowflakes-shake {
  0% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
  50% {
    -webkit-transform: translateX(80px);
    transform: translateX(80px);
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}
@keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@keyframes snowflakes-shake {
  0% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(80px);
  }
  100% {
    transform: translateX(0px);
  }
}
.snowflake {
  position: fixed;
  top: -10%;
  z-index: 9999;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
  -webkit-animation-name: snowflakes-fall, snowflakes-shake;
  -webkit-animation-duration: 10s, 3s;
  -webkit-animation-timing-function: linear, ease-in-out;
  -webkit-animation-iteration-count: infinite, infinite;
  -webkit-animation-play-state: running, running;
  animation-name: snowflakes-fall, snowflakes-shake;
  animation-duration: 10s, 3s;
  animation-timing-function: linear, ease-in-out;
  animation-iteration-count: infinite, infinite;
  animation-play-state: running, running;
}
.snowflake:nth-of-type(0) {
  left: 1%;
  -webkit-animation-delay: 0s, 0s;
  animation-delay: 0s, 0s;
}
.snowflake:nth-of-type(1) {
  left: 10%;
  -webkit-animation-delay: 1s, 1s;
  animation-delay: 1s, 1s;
}
.snowflake:nth-of-type(2) {
  left: 20%;
  -webkit-animation-delay: 6s, 0.5s;
  animation-delay: 6s, 0.5s;
}
.snowflake:nth-of-type(3) {
  left: 30%;
  -webkit-animation-delay: 4s, 2s;
  animation-delay: 4s, 2s;
}
.snowflake:nth-of-type(4) {
  left: 40%;
  -webkit-animation-delay: 2s, 2s;
  animation-delay: 2s, 2s;
}
.snowflake:nth-of-type(5) {
  left: 50%;
  -webkit-animation-delay: 8s, 3s;
  animation-delay: 8s, 3s;
}
.snowflake:nth-of-type(6) {
  left: 60%;
  -webkit-animation-delay: 6s, 2s;
  animation-delay: 6s, 2s;
}
.snowflake:nth-of-type(7) {
  left: 70%;
  -webkit-animation-delay: 2.5s, 1s;
  animation-delay: 2.5s, 1s;
}
.snowflake:nth-of-type(8) {
  left: 80%;
  -webkit-animation-delay: 1s, 0s;
  animation-delay: 1s, 0s;
}
.snowflake:nth-of-type(9) {
  left: 90%;
  -webkit-animation-delay: 3s, 1.5s;
  animation-delay: 3s, 1.5s;
}
/* Demo Purpose Only*/
.demo {
  font-family: "Raleway", sans-serif;
  color: #fff;
  display: block;
  margin: 0 auto;
  padding: 15px 0;
  text-align: center;
}
.demo a {
  font-family: "Raleway", sans-serif;
  color: rgb(255, 255, 255);
}
/*  */

.btn-purple{
  /*#ec376a*/
    color: #fff !important;
    border-color: rgb(255,95,45)!important; 
    background-color: rgb(255,95,45)!important;
}

.btn-purple:hover
{
    color: #fff !important;
    /*#f7618c*/
    border-color: rgb(250, 129, 92)!important; 
    background-color: rgb(254, 110, 66)!important;
}
.btn-purple:focus,
.btn-purple.focus
{
    color: #fff !important;
    border-color: rgb(250, 129, 92)!important;
    background-color: rgb(254, 110, 66) !important;
    box-shadow: 0 0 0 .2rem rgba(255, 109, 65, 0.468) !important;
}
.btn-purple.disabled,
.btn-purple:disabled
{
    color: #fff !important;
    border-color: rgb(255,95,45)!important;
    background-color: rgb(255,95,45)!important;
}
.btn-purple:not(:disabled):not(.disabled):active,
.btn-purple:not(:disabled):not(.disabled).active,
.show > .btn-purple.dropdown-toggle
{
    color: #fff !important;
    border-color: rgb(255,95,45)!important; 
    background-color: rgb(250, 129, 92) !important;
}
.btn-purple:not(:disabled):not(.disabled):active:focus,
.btn-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-purple.dropdown-toggle:focus
{
    box-shadow: 0 0 0 .2rem rgba(255, 109, 65, 0.468) !important;
}
a{
  font-family: "Kanit", sans-serif;
}
li{
  font-family: "Kanit", sans-serif;
}

</style>
